import React, { Fragment, useState, useEffect } from "react";
import { Sidebar } from "../../partials/Sidebar";
import { Navbar } from "../../partials/Navbar";
import * as userService from "../../services/subscribers.service";
import LoadingIcon from "../../components/LoadingIcon";
import { formatDateToString } from "../../utils/common";
import SubscriberListItem from "../../components/subscriberListItem";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { clearState } from "../../redux/actions/authActions";
import Layout from "../../layout";

export default function CategoryList() {
  const accessToken = useSelector((state) => state.auth.user.accessToken);
  const userDetails = useSelector((state) => state.auth.user);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const [pageCount, setPageCount] = useState(null);
  const now = new Date();
  const [startDate, setStartDate] = useState(
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30)
  );
  const [endDate, setEndDate] = useState(now);
  const dispatch = useDispatch();
  const getData = () => {
    userService
      .list(
        currentPage,
        limit,
        formatDateToString(startDate),
        formatDateToString(endDate),
        accessToken
      )
      .then((response) => {
        console.log(response)
        if (response.status === 200) {
          setUsers(response.data.data.rows);
          setPageCount(Math.ceil(response.data.data.count / limit));
          setLoading(false);
        } else {
          console.log(response)
        };
      })
      .catch((error) => {
                    if(error.response.status === 401) {
                          dispatch(clearState())
                    }
                })
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, startDate, endDate]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  return (
    <Layout>
      <div>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <Navbar sidebarOpen={sidebarOpen} userDetails={userDetails}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">
              Subscribers
            </h1>
            <div className="flex my-5">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                wrapperClassName="date-picker-wrapper"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                wrapperClassName="date-picker-wrapper"
              />
            </div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            {/* Replace with your content */}
            <div className="py-4">
              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    {loading ? (
                      <LoadingIcon />
                    ) : users && users.length > 0 ? (
                      <>
                        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                              <tr>
                                <th
                                  scope="col"
                                  className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Number
                                </th>
                                <th
                                  scope="col"
                                  className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Operator
                                </th>
                                <th
                                  scope="col"
                                  className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Amount
                                </th>
                                <th
                                  scope="col"
                                  className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Status
                                </th>
                                <th scope="col" className="relative px-5 py-3">
                                  <span className="sr-only">Edit</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                              {users.map((user, userIndex) => (
                                <SubscriberListItem
                                  key={user.id}
                                  user={user}
                                  evenIndex={userIndex % 2 === 0}
                                />
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="pagination my-4 w-full mx-8">
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel="Next"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            pageCount={pageCount}
                            previousLabel="Prev"
                            renderOnZeroPageCount={null}
                            pageClassName="pagination-item"
                            breakClassName="pagination-item"
                            pageLinkClassName="pagination-item-link"
                            containerClassName="pagination"
                            activeClassName="active"
                            disabledClassName="disabled"
                          />
                        </div>
                      </>
                    ) : (
                      <div className="text-center m-12">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="mx-auto h-12 w-12 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                        <h3 className="mt-2 text-sm font-medium text-gray-900">
                          No Subscribers
                        </h3>
                        <p className="mt-1 text-sm text-gray-500">
                          No Subscribers on this date range.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* /End replace */}
          </div>
        </Navbar>
      </div>
    </Layout>
  );
}
